import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  IExperienceDenormalizedV2,
  PARTICIPANT_ACTOR_KEY
} from '@dadohr/shared/domainTypes/experience';
import { Typography } from '@material-ui/core';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import { toFullName } from '../../../../../../services/user';
import { WithBreakpoints } from '../Breakpoints';

export const ParticipantAwareTitle = ({
  d
}: {
  d: Doc<IExperienceDenormalizedV2>;
}) => {
  const isParticipant = d.data.actor === PARTICIPANT_ACTOR_KEY;
  return (
    <FlexContainerVertical fullWidth spacing={0.5}>
      {isParticipant ? (
        <Typography variant="h2">{d.data.title}</Typography>
      ) : (
        <WithBreakpoints
          lgMdSm={
            <>
              <Typography variant="caption">
                <Typography variant="h6">
                  {toFullName(d.data.participant)}
                </Typography>
              </Typography>
              <Typography variant={'h3'}>{d.data.title}</Typography>
            </>
          }
          xs={
            <>
              <Typography variant="caption">
                {toFullName(d.data.participant)}
              </Typography>
              <Typography variant={'h4'}>{d.data.title}</Typography>
            </>
          }
        />
      )}
    </FlexContainerVertical>
  );
};
